<template>
  <div id="salemarket">
    <my-header></my-header>
    <div class="pd10">
      <div id="sale-market" class="sale-market">
        <div v-if="show_header">
          <sale-market-head></sale-market-head>
        </div>
        <ol class="breadcrumb" v-if="detail">
          <li>
            <router-link :to="{ name: 'SaleMarket', params: { }}">{{'Sale Market'|translate}}</router-link>
          </li>
          <li v-if="product">
            
            {{product.name}}
          </li>
          <li class="active" v-if="detail">{{detail.varriant_name}}</li>
        </ol>
        <div class="row" v-if="detail">
          <div class="col-md-9 mb20">
            <div class="media mb20">
              <div class="media-left">
                <img
                  v-if="product"
                  :src="product.feature_image_path"
                  class="media-object"
                  style="width:160px"
                />
              </div>
              <div class="media-body">
                <h3 class="media-heading">{{detail.varriant_name}}</h3>
                <p>
                  <i class="fas fa-truck"></i>
                  {{detail.source_name}} ({{detail.source_type|translate}})
                </p>
                <p>{{toCommas(detail.price)}}{{'price_unit'|translate}} /{{detail.unit_name}}</p>
                <p class="mt10 alert alert-warning" v-if="!user">{{'Login to make order'|translate}}</p>
                <div v-if="user">
                  <p>
                    <strong>{{'Amount'|translate}}</strong>
                  </p>
                  <div class="input-group" style="width:200px">
                    <input
                      type="number"
                      class="form-control"
                      min="1"
                      :placeholder="'Amount'|translate"
                      v-model="order_quantity"
                      ref="order_amount"
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-primary"
                        v-on:click="addToCart"
                        type="button"
                      >Add to cart</button>
                    </span>
                  </div>
                  <!-- /input-group -->
                </div>
              </div>
            </div>
            
            <div class="description title-group mt20 mb30" v-if="detail.variant_note">
              <h4><i class="fas fa-certificate"></i> {{'Variant Description'|translate}}</h4>
              <p>{{detail.variant_note}}</p>
            </div>
            <div class="description title-group" v-if="detail.description">
            <h4> <i class="fas fa-certificate"></i> {{'Description'|translate}}</h4>
              <div  v-html="detail.description"></div>
            </div>
          </div>
          <div class="col-md-3" v-if="store">
            <div class="media">
              <div class="media-body">
                <h4 class="media-heading">
                  <router-link :to="{ name: 'SaleMarketStore', params: { store_id: store.id }}">
                    <i class="fas fa-store-alt"></i>
                    {{store.name}}
                  </router-link>
                </h4>
              </div>
            </div>
            <hr />
            <p v-if="store.commune_name">
              <i class="fas fa-map-marker"></i>
              {{ store.commune_name }},{{ store.district_name }},{{ store.province_name }}
            </p>
            <p v-if="store.facebook">
              <a :href="store.facebook">
                <i class="fab fa-facebook"></i>
                 Facebook
              </a>
            </p>

            <a class="btn btn-primary mt10" :href="'tel:'+ store.phone">
              <i class="fas fa-phone"></i>
              {{store.phone}}
            </a>
          </div>
        </div>
      </div>
      <!-- end #sale-market -->
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import Paginate from "vuejs-paginate";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
export default {
  name: "SaleAdMarketDetail",
  components: {
    MyHeader,
    Loading,
    Paginate,
    SaleMarketHead
  },
  data() {
    let data = {
      ad_id: null,
      detail: null,
      product: null,
      ordering: false,
      store: null,
      order_quantity: 1,
      show_header: true,
      user: null
    };

    return data;
  },

  methods: {
    buy() {
      if (this.order_amount <= 0) {
        return this.$alertify.alertWithTitle(
          this.$t("Confirm"),
          this.$t("Please enter amount")
        );
      }
    },
    toCommas(value) {
      return Utils.toCommas(value);
    },

    getDetail() {
      Utils.request(this, true, "salemarket")
        .get(
          `/adDetail/?${Utils.arrayToRequestParam({
            id: this.ad_id
          })}`
        )
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.detail = data.data;
            // console.log("this.detail", this.detail);
            this.getActiveProduct();
            this.getStore();
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    getActiveProduct() {
      Utils.getAllProducts(this, {}).then(data => {
        var allProducts = data;

        var products = allProducts.filter(item => {
          return item.id == this.detail.product_id;
        });

        if (products.length > 0) {
          this.product = products[0];
        }
      });
    },
    getStore() {
      let data = {
        offset: 0,
        limit: 1,
        id: this.detail.store_id
      };

      Utils.request(this, true, "store")
        .get(`/getStore/${this.detail.store_id}`)
        .then(data => {
          //console.log('data',data.data.data.)
          this.store = data.data.data.list[0];
        });
    },
    addToCart() {
      let data = {
        ad_id: this.detail.id,
        store_id: this.store.id,
        quantity: this.order_quantity,
        action: "add"
      };

      Utils.request(this, true, "salemarket")
        .post("/toggleToCart", data)
        .then(response => {
          let data = response.data;
          if (data.status == "ok") {
            this.$alertify.alertWithTitle(
              this.$t("Confirm"),
              this.$t("Your order is placed successfully")
            );
            this.order_quantity = 0;
            this.show_header = false;
            setTimeout(() => {
              this.show_header = true;
            }, 10);
          } else {
            this.$alertify.alertWithTitle(this.$t("Error"), this.$t(data.data));
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    }
  },
  mounted() {
    this.ad_id = this.$route.params.ad_id;
    this.user = Utils.getUser(this);

    this.getDetail();
  },
  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleAdMarketDetail.vue